<script>
export default {
  data() {
    return {
      not_found: {
        noItems: "Nenhum registro encontrado",
      },
      checkOptions: false,
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,

      fieldsPacientes: [
        { key: "mes", label: "Mês", _style: "min-width:200px" },

        {
          key: "total_atendimentos",
          label: "Pacientes Atendidos",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "total_baixas",
          label: "Baixas",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "churn",
          label: "Churn",
          _style: "min-width:40px;",
          sorter: false,
          filter: false,
        },
      ],
      arrFieldsPacientes: [],
      arrCardsPacientes: [],
      totAtendimentos: 0,
      totPacienteBaixas:0,
      churn:0,
      arrMesesAno: [
        { label: "Todos", value: 0 },
        { label: "Janeiro", value: 1 },
        { label: "Fevereiro", value: 2 },
        { label: "Março", value: 3 },
        { label: "Abril", value: 4 },
        { label: "Maio", value: 5 },
        { label: "Junho", value: 6 },
        { label: "Julho", value: 7 },
        { label: "Agosto", value: 8 },
        { label: "Setembro", value: 9 },
        { label: "Outubro", value: 10 },
        { label: "Novembro", value: 11 },
        { label: "Dezembro", value: 12 },
      ],
      arrAnosRegistrados: [],
      arrConvenios: [{ label: "Todos", value: 0 }],
      arrProfissionais: [{ label: "Todos", value: 0 }],
      paramsFilter: {
        paramsMes: null,
        paramsAno: null,
        paramsConvenio: null,
        paramsProfissional: null,
      },
      btn_ver: false,
      count: 0,
    };
  },
  methods: {
    carregarDadosCards() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_BASE_URL}carregar-dados-pacientes-gerais`
        )
        .then((res) => res.json())
        .then((res) => {
          this.arrCardsPacientes = res[0];
          this.paramsFilter.paramsAno = res[0].ano;
          this.paramsFilter.paramsMes = parseInt(res[0].mes);
        });
    },
    carregarDadosTabelaPacientes() {
      this.arrFieldsPacientes = []
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}carregar-tabela-pacientes-gerais`,
            this.paramsFilter
        )
        .then((res) => res.json())
        .then((res) => {
         
          res.forEach((elem) => {
            this.arrFieldsPacientes.push(elem);
          });
        })
        .then((res)=>{
          this.arrFieldsPacientes.forEach(async (p)=>{
            let mes = ''
              if (p.mes === "Janeiro") {
                  mes = 1;
              } else if (p.mes === "Fevereiro") {
                  mes = 2;
              } else if (p.mes === "Março") {
                  mes = 3;
              } else if (p.mes === "Abril") {
                  mes = 4;
              } else if (p.mes === "Maio") {
                  mes = 5;
              } else if (p.mes === "Junho") {
                  mes = 6;
              } else if (p.mes === "Julho") {
                  mes = 7;
              } else if (p.mes === "Agosto") {
                  mes = 8;
              } else if (p.mes === "Setembro") {
                  mes = 9;
              } else if (p.mes === "Outubro") {
                  mes = 10;
              } else if (p.mes === "Novembro") {
                  mes = 11;
              } else if (p.mes === "Dezembro") {
                  mes = 12;
              }

            this.$http.post(`${process.env.VUE_APP_API_BASE_URL}pacientes/total-baixas`,{ params: {
              paramsMes: mes,
              paramsAno: this.paramsFilter.paramsAno,
              paramsConvenio: null,
              paramsProfissional: null
            } })
            .then((res)=>res.json())
            .then((res)=>{
              p.total_baixas = res[0].count
              if(p.total_atendimentos == 0){
                p.churn = "0,00%"  
              }else{
                p.churn = `${((res[0].count/p.total_atendimentos)*100).toFixed(2)}%`
              }
              
            })
          })
          
        })
    },
    carregarAnosRegistrados() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-anos-registrados`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.arrAnosRegistrados.push(elem.ano);
          });
        });
    },
    carregarConvenios() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.arrConvenios.push(elem.convenios);
          });
        });
    },
    carregarProfissionais() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}carregar-profissionais`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.arrProfissionais.push(elem.profissional);
          });
        });
    },
    async filtrarDadosPaciente() {
      // this.$http
      //   .post(`${process.env.VUE_APP_API_BASE_URL}filtrar-dash-pacientes`, {
      //     params: this.paramsFilter,
      //   })
      //   .then((res) => res.json())
      //   .then((res) => {
      //     this.arrFieldsPacientes = [];
      //     if (this.paramsFilter.paramsMes != 0) {
      //       this.arrCardsPacientes = res[0];
      //       this.arrFieldsPacientes.push({
      //         mes: res[0].mes,
      //         total_atendimentos: res[0].total_atendimentos,
      //         total_baixas: res[0].total_baixas,
      //         churn: res[0].churn,
      //       });
      //     } else {
      //       this.arrCardsPacientes = res[0];
      //       this.arrFieldsPacientes = res;
      //     }
      //   });
      this.carregarDadosTabelaPacientes()
      try {
        const [res1,res2] = await Promise.all([
          this.$http.post(`${process.env.VUE_APP_API_BASE_URL}consultas/total-atendidas`,{ params: this.paramsFilter }),
          this.$http.post(`${process.env.VUE_APP_API_BASE_URL}pacientes/total-baixas`,{ params: this.paramsFilter })
        ])

  
        this.totAtendimentos = res1.body[0].count
        this.totPacienteBaixas = res2.body[0].count
        this.churn = ((this.totPacienteBaixas / this.totAtendimentos)  * 100).toFixed(2)
        if(isNaN(this.churn)){
          this.churn = 0
        }
     
      } catch (error) {
        console.error(error)
      }
    },
  },
  mounted() {
    this.carregarDadosCards();
    this.carregarDadosTabelaPacientes();
    this.carregarAnosRegistrados();
    this.carregarConvenios();
    this.carregarProfissionais();
    

    this.paramsFilter.paramsMes = new Date().getMonth() + 1
    this.paramsFilter.paramsAno - new Date().getFullYear();
    this.filtrarDadosPaciente();
  },
};
</script>
<template>
  <CCard>
    <CCardBody>
      <!-- Filtros para tabela e cards -->
      <CSelect
        :value.sync="paramsFilter.paramsMes"
        :options="arrMesesAno"
        v-model="paramsFilter.paramsMes"
        placeholder="Filtrar por mês"
        prepend="Meses"
        ref="meses do ano"
        @change="filtrarDadosPaciente()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
      <CSelect
        :value.sync="paramsFilter.paramsAno"
        :options="arrAnosRegistrados"
        v-model="paramsFilter.paramsAno"
        placeholder="Filtrar por ano"
        prepend="Ano"
        ref="anos registrados"
        @change="filtrarDadosPaciente()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
      <CSelect
        :value.sync="paramsFilter.paramsConvenio"
        :options="arrConvenios"
        v-model="paramsFilter.paramsConvenio"
        placeholder="Filtrar por convênio"
        prepend="Convênios"
        ref="Convênios"
        @change="filtrarDadosPaciente()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
      <CSelect
        :value.sync="paramsFilter.paramsProfissional"
        :options="arrProfissionais"
        placeholder="Filtrar por profissionais"
        prepend="Profissionais"
        ref="Profissionais"
        @change="filtrarDadosPaciente()"
      >
        <template #append-content>
          <CIcon name="cil-badge" />
        </template>
      </CSelect>
    </CCardBody>
    <!-- Tabela e Cards -->
    <CCardBody class="card-body">
      <CRow>
        <div class="div_cards">
          <div class="div-cards-value-evolution">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Total Atendimentos
              </p>
              <p class="extra-info-title">
                {{ totAtendimentos }}
              </p>
            </fieldset>
          </div>
          <div class="div-cards-value-evolution">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Nº Baixas
              </p>
              <p class="extra-info-title">
                {{ totPacienteBaixas }}
              </p>
            </fieldset>
          </div>
          <div class="div-cards-value-evolution">
            <span id="rec"></span>
            <fieldset>
              <p class="title">
                Churn
              </p>
              <p class="extra-info-title">
                {{ churn }}%
              </p>
            </fieldset>
          </div>
        </div>
      </CRow>

      <CDataTable
        :items="arrFieldsPacientes"
        :fields="fieldsPacientes"
        :noItemsView="not_found"
        column-filter
        hover
        searching
        sorter
        small
        :fixed="fixed"
        :items-per-page="12"
        :dark="dark"
        pagination
      >
      </CDataTable>
    </CCardBody>
  </CCard>
</template>
<style scoped>
.card-body {
  font-size: 14px;
  font-weight: 400;
}
.div_cards {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1em;
  margin-bottom: 2em;
}
.div_cards div {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 0.1em 1.5em;
  /* flex-grow: 1; */
  width: 20%;
  position: relative;
}
.div-cards-value-evolution {
  width: 50% !important;
  height: 17vh;
  cursor: pointer;
  display: flex !important;
  place-content: center;
  overflow: hidden;
}

#rec {
  background-color: #203864 !important;
  width: 2px !important;
  position: absolute;
  left: 0px;
  bottom: 0px;
  padding: 6px;
  height: 80%;
}
.title {
  font-size: 25px;
  color: #666;
  transition: all 0.4s;
  font-weight: 600;
}

@media (max-width: 1700px) {
  .valueP {
    font-size: 26px;
  }
}

@media (max-width: 1400px) {
  .valueP {
    font-size: 18px;
  }
  .title {
    font-size: 14px;
    color: #666;
  }
}
.div-checkbox-options {
  padding-left: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
fieldset {
  position: absolute;
  text-align: center;
}
fieldset .extra-info-title {
  font-weight: 600;
  font-size: 25px;
}
</style>
